import { AgGridReact, DropdownButton, Flex, HelpIndicator, Tag, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { WorkspaceUserData } from "~/pages/UserAndRoles/WorkspacesPage/types";
import { SPACING } from "~/styles/variables";
import * as styles from "../styles_vanilla.css";

type AssignedUsersCellParams = {
  onRemoveUser: (user: WorkspaceUserData | null) => void;
};

type CellParamsType = AgGridReact.CustomCellRendererProps<WorkspaceUserData> &
  AssignedUsersCellParams;

export const StatusCell = ({ value }: AgGridReact.CustomCellRendererProps) => {
  const color = value ? Colors.Success600 : Colors.Neutral600;
  const text = value ? "Active" : "Inactive";
  const iconType = value ? "check" : "times";
  const textVariant = value ? "strong-md" : "secondary-md";
  return (
    <Flex flexDirection="row" alignItems="center" gap={8} className={styles.cellComponent}>
      {<Icon type={iconType} variant="solid" color={color} size="medium" />}
      <Text variant={textVariant} color={color}>
        {text}
      </Text>
    </Flex>
  );
};

export const RoleCell = ({ value }: AgGridReact.CustomCellRendererProps) => {
  return (
    <Flex
      flexDirection="row"
      alignItems="center"
      className={styles.cellComponent}
      justifyContent="space-between"
    >
      <Tag label={value} variant="neutral" />
    </Flex>
  );
};

export const CellWithAction = ({ value, data, onRemoveUser }: CellParamsType) => {
  return (
    <Flex
      flexDirection="row"
      alignItems="center"
      className={styles.cellComponent}
      gap={SPACING.X_SMALL}
      justifyContent="space-between"
    >
      <HelpIndicator id="last-accessed-tooltip" placement="top" content={value}>
        <Text className={styles.TableCellText}>{value}</Text>
      </HelpIndicator>
      <DropdownButton
        icon="ellipsis-h"
        variant="link"
        direction="down"
        usePortal
        align="right"
        className={styles.removeUserButton}
      >
        <DropdownButton.Action>
          <Flex
            role="button"
            alignItems="center"
            gap={SPACING.X_SMALL}
            onClick={() => onRemoveUser?.(data ?? null)}
            className={styles.removeUserButton}
          >
            <Icon type="minus-circle" className={styles.actionIcon} />
            <Text>Remove user</Text>
          </Flex>
        </DropdownButton.Action>
      </DropdownButton>
    </Flex>
  );
};
